// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Divider__container-f4ab72 {
  --ui-divider-vertical-offset: 10px;
  --ui-divider-left-offset: 0;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--base-15);
  --ui-divider-height: 12px;
  display: block;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 0 none;
  padding: var(--ui-divider-vertical-offset) var(--ui-divider-right-offset) var(--ui-divider-vertical-offset) var(--ui-divider-left-offset);
}

.Divider__container-f4ab72::after {
  content: "";
  display: block;
  background-color: var(--ui-divider-color);
  height: var(--ui-divider-height);
  width: 100%;
}

.Divider__theme-style1-e3aa7a {
  --ui-divider-vertical-offset: 10px;
  --ui-divider-left-offset: 0;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--base-15);
  --ui-divider-height: 12px;
}

.Divider__theme-style2-a3804e {
  --ui-divider-vertical-offset: 8px;
  --ui-divider-left-offset: 64px;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--base-120_08);
  --ui-divider-height: 1px;
}

.Divider__theme-style3-d94744 {
  --ui-divider-vertical-offset: 8px;
  --ui-divider-left-offset: 24px;
  --ui-divider-right-offset: 24px;
  --ui-divider-color: var(--base-120_08);
  --ui-divider-height: 1px;
}

.Divider__theme-style4-b324cd {
  --ui-divider-vertical-offset: 4px;
  --ui-divider-left-offset: 16px;
  --ui-divider-right-offset: 16px;
  --ui-divider-color: var(--base-120_08);
  --ui-divider-height: 1px;
}

.Divider__theme-style5-ebf4f4 {
  --ui-divider-vertical-offset: 0;
  --ui-divider-left-offset: 0;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--base-15);
  --ui-divider-height: 12px;
}

.Divider__theme-style6-cfb76e {
  --ui-divider-vertical-offset: 16px;
  --ui-divider-left-offset: 24px;
  --ui-divider-right-offset: 24px;
  --ui-divider-color: var(--base-120_08);
  --ui-divider-height: 1px;
}

.Divider__theme-style7-ce502b {
  --ui-divider-vertical-offset: 10px;
  --ui-divider-left-offset: 0px;
  --ui-divider-right-offset: 0px;
  --ui-divider-color: var(--addition-180);
  --ui-divider-height: 12px;
}

.Divider__theme-style8-c38f66 {
  --ui-divider-vertical-offset: 4px;
  --ui-divider-left-offset: 0;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--base-120_08);
  --ui-divider-height: 1px;
}

.Divider__theme-style9-c11f9f {
  --ui-divider-vertical-offset: 0;
  --ui-divider-left-offset: 0;
  --ui-divider-right-offset: 0;
  --ui-divider-color: var(--addition-180);
  --ui-divider-height: 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Divider/Divider.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,yBAAA;EAEA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,yIAAA;AAAF;;AAIA;EACE,WAAA;EACA,cAAA;EACA,yCAAA;EACA,gCAAA;EACA,WAAA;AADF;;AAIA;EACE,kCAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,yBAAA;AADF;;AAIA;EACE,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,wBAAA;AADF;;AAIA;EACE,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,sCAAA;EACA,wBAAA;AADF;;AAIA;EACE,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,sCAAA;EACA,wBAAA;AADF;;AAIA;EACE,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,yBAAA;AADF;;AAIA;EACE,kCAAA;EACA,8BAAA;EACA,+BAAA;EACA,sCAAA;EACA,wBAAA;AADF;;AAIA;EACE,kCAAA;EACA,6BAAA;EACA,8BAAA;EACA,uCAAA;EACA,yBAAA;AADF;;AAIA;EACE,iCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,wBAAA;AADF;;AAIA;EACE,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,uCAAA;EACA,yBAAA;AADF","sourcesContent":[".container {\n  --ui-divider-vertical-offset: 10px;\n  --ui-divider-left-offset: 0;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--base-15);\n  --ui-divider-height: 12px;\n\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  border: 0 none;\n  padding: var(--ui-divider-vertical-offset) var(--ui-divider-right-offset)\n    var(--ui-divider-vertical-offset) var(--ui-divider-left-offset);\n}\n\n.container::after {\n  content: '';\n  display: block;\n  background-color: var(--ui-divider-color);\n  height: var(--ui-divider-height);\n  width: 100%;\n}\n\n.theme-style1 {\n  --ui-divider-vertical-offset: 10px;\n  --ui-divider-left-offset: 0;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--base-15);\n  --ui-divider-height: 12px;\n}\n\n.theme-style2 {\n  --ui-divider-vertical-offset: 8px;\n  --ui-divider-left-offset: 64px;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--base-120_08);\n  --ui-divider-height: 1px;\n}\n\n.theme-style3 {\n  --ui-divider-vertical-offset: 8px;\n  --ui-divider-left-offset: 24px;\n  --ui-divider-right-offset: 24px;\n  --ui-divider-color: var(--base-120_08);\n  --ui-divider-height: 1px;\n}\n\n.theme-style4 {\n  --ui-divider-vertical-offset: 4px;\n  --ui-divider-left-offset: 16px;\n  --ui-divider-right-offset: 16px;\n  --ui-divider-color: var(--base-120_08);\n  --ui-divider-height: 1px;\n}\n\n.theme-style5 {\n  --ui-divider-vertical-offset: 0;\n  --ui-divider-left-offset: 0;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--base-15);\n  --ui-divider-height: 12px;\n}\n\n.theme-style6 {\n  --ui-divider-vertical-offset: 16px;\n  --ui-divider-left-offset: 24px;\n  --ui-divider-right-offset: 24px;\n  --ui-divider-color: var(--base-120_08);\n  --ui-divider-height: 1px;\n}\n\n.theme-style7 {\n  --ui-divider-vertical-offset: 10px;\n  --ui-divider-left-offset: 0px;\n  --ui-divider-right-offset: 0px;\n  --ui-divider-color: var(--addition-180);\n  --ui-divider-height: 12px;\n}\n\n.theme-style8 {\n  --ui-divider-vertical-offset: 4px;\n  --ui-divider-left-offset: 0;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--base-120_08);\n  --ui-divider-height: 1px;\n}\n\n.theme-style9 {\n  --ui-divider-vertical-offset: 0;\n  --ui-divider-left-offset: 0;\n  --ui-divider-right-offset: 0;\n  --ui-divider-color: var(--addition-180);\n  --ui-divider-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Divider__container-f4ab72`,
	"theme-style1": `Divider__theme-style1-e3aa7a`,
	"themeStyle1": `Divider__theme-style1-e3aa7a`,
	"theme-style2": `Divider__theme-style2-a3804e`,
	"themeStyle2": `Divider__theme-style2-a3804e`,
	"theme-style3": `Divider__theme-style3-d94744`,
	"themeStyle3": `Divider__theme-style3-d94744`,
	"theme-style4": `Divider__theme-style4-b324cd`,
	"themeStyle4": `Divider__theme-style4-b324cd`,
	"theme-style5": `Divider__theme-style5-ebf4f4`,
	"themeStyle5": `Divider__theme-style5-ebf4f4`,
	"theme-style6": `Divider__theme-style6-cfb76e`,
	"themeStyle6": `Divider__theme-style6-cfb76e`,
	"theme-style7": `Divider__theme-style7-ce502b`,
	"themeStyle7": `Divider__theme-style7-ce502b`,
	"theme-style8": `Divider__theme-style8-c38f66`,
	"themeStyle8": `Divider__theme-style8-c38f66`,
	"theme-style9": `Divider__theme-style9-c11f9f`,
	"themeStyle9": `Divider__theme-style9-c11f9f`
};
module.exports = ___CSS_LOADER_EXPORT___;
